import arrayPrototypeAt from '../polyfills/arrayPrototypeAt'

if (Array.prototype.at === undefined) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'at', {
    value(this: any[], index: number): any {
      return arrayPrototypeAt(this, index)
    },
  })
}
